import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import InputAdornment from '@mui/material/InputAdornment';
import Tooltip from '@mui/material/Tooltip';
import CancelIcon from '@mui/icons-material/Cancel';
import { HoverActionButton } from '@cbridge-tools/button';
import { IClearButtonAdornmentProps } from './ClearButtonAdornment.interface';

export const ClearButtonAdornment: FunctionComponent<IClearButtonAdornmentProps> = ({ hidden, onClick, isSearch, edge = 'end' }) => {
  const { t } = useTranslation();

  if (hidden) {
    return null;
  }

  const title = isSearch ? t('text:common.filter.clearSearch') : t('text:common.filter.clearValue');

  return (
    <InputAdornment position={'end'}>
      <HoverActionButton
        aria-label={title}
        onClick={onClick}
        edge={edge}
      >
        <Tooltip title={title}>
          <CancelIcon />
        </Tooltip>
      </HoverActionButton>
    </InputAdornment>
  );
};
